export const state = {
	currentStep: 0,
	stepData: {},
	steps: [
		{
			title: 'Welcome',
			component: 'Home',
			required: true,
		},
		{
			title: 'Setup',
			component: 'Store',
			required: false,
		},
		{
			title: 'Product',
			component: 'Product',
			required: false,
		},
		{
			title: 'Profile',
			component: 'Profile',
			required: false,
		},
		{
			title: 'Socials',
			component: 'Socials',
			required: false,
		},
	],
}

export const getters = {
	currentStep: state => state.currentStep,
	currentStepComponent: state => {
		const step = state.steps[state.currentStep]
		return step.component
	},
	currentStepData: state => state.stepData[state.currentStep] || {},
	canProceed: state => {
		const currentStepConfig = state.steps[state.currentStep]
		if (!currentStepConfig.required) return true

		// Check if required data is present
		const stepData = state.stepData[state.currentStep]
		return stepData && stepData.completed
	},
	steps: state => state.steps,
	stepData: state => state.stepData,
}

export const mutations = {
	setCurrentStep(state, stepIndex) {
		state.currentStep = stepIndex
	},
	setStepData(state, { stepIndex, data }) {
		state.stepData = {
			...state.stepData,
			[stepIndex]: data,
		}
	},
	updateStepData(state, { stepIndex, updates }) {
		state.stepData = {
			...state.stepData,
			[stepIndex]: {
				...state.stepData[stepIndex],
				...updates,
			},
		}
	},
	resetStepData(state) {
		state.stepData = {}
		state.currentStep = 0
	},
}

export const actions = {
	// Navigate to a specific step
	goToStep({ commit }, stepIndex) {
		if (stepIndex >= 0 && stepIndex < state.steps.length) {
			commit('setCurrentStep', stepIndex)
		}
	},

	// Handle step completion with action-based navigation
	handleStepComplete({ commit, state, dispatch }, data) {
		// Check if the action is to go to store
		if (data.action === 'go-to-store') {
			dispatch('goToStep', 1)
			return
		}

		// Check if the action is to go to product
		if (data.action === 'go-to-product') {
			dispatch('goToStep', 2)
			return
		}

		// Check if the action is to go to home
		if (data.action === 'go-to-home') {
			dispatch('goToStep', 0)
			return
		}

		if (data.action === 'go-to-profile') {
			dispatch('goToStep', 3)
			return
		}

		if (data.action === 'go-to-socials') {
			dispatch('goToStep', 4)
			return
		}

		// Store step data
		commit('setStepData', {
			stepIndex: state.currentStep,
			data: {
				...data,
				completed: true,
				completedAt: new Date(),
			},
		})
	},

	// Handle step back navigation
	handleStepBack({ state, dispatch }) {
		if (state.currentStep > 0) {
			dispatch('goToStep', state.currentStep - 1)
		}
	},

	// Handle step skip
	handleStepSkip({ commit, state }) {
		commit('setStepData', {
			stepIndex: state.currentStep,
			data: {
				skipped: true,
				skippedAt: new Date(),
			},
		})
	},

	// Reset the entire dashboard state
	resetDashboard({ commit }) {
		commit('resetStepData')
	},

	// Complete a specific step
	completeStep({ commit, state }, stepData = {}) {
		commit('setStepData', {
			stepIndex: state.currentStep,
			data: {
				...stepData,
				completed: true,
				completedAt: new Date(),
			},
		})
	},

	// Skip a specific step
	skipStep({ commit, state }, stepData = {}) {
		commit('setStepData', {
			stepIndex: state.currentStep,
			data: {
				...stepData,
				skipped: true,
				skippedAt: new Date(),
			},
		})
	},
}
